import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ManagementService } from '../../services/management.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { IComboBase } from '../../../interfaces/base/base.interface';

@Component({
  selector: 'app-jobposition-register-modal',
  templateUrl: './jobposition-register-modal.component.html',
  styleUrl: './jobposition-register-modal.component.scss',
  providers: [DialogService],
})
export class JobpositionRegisterModalComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() areaId: number | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerJobPositionComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  jobPosition: string | null = null;
  isLoading: boolean = false;
  selectedArea: IComboBase | null = null;
  filteredOptions: IComboBase[] = [];
  areas: IComboBase[] = [];

  hasInteracted: { [key: string]: boolean } = {
    area: false,
    jobPosition: false,
  };

  constructor(
    private managementService: ManagementService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes['areaId'] && changes['areaId'].currentValue !== null) {
      this.loadAreaData();
    }
  }

  private loadAreaData(): void {
    this.isLoading = true;
    if (!this.areaId) return;

    this.managementService.getAreaByAreaId(this.areaId).subscribe({
      next: (areaData) => {
        this.areas = [areaData];
        this.selectedArea = {
          key: areaData.areaId,
          text: areaData.areaName,
        };

        this.filteredOptions = this.areas;
        this.hasInteracted['area'] = true;
        this.isLoading = false;
        this.validateForm();
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error al obtener el área:', err);
      },
    });
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'area':
        this.selectedArea = null;
        break;
      case 'jobPosition':
        this.jobPosition = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  filterOptions(event: any, type: string) {
    const query = event.query.toLowerCase();
    let options: IComboBase[] = [];
    switch (type) {
      case 'area':
        options = this.areas;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.filteredOptions = options.filter((option) =>
      option.text.toLowerCase().includes(query)
    );
  }

  onSelect(event: any, type: string) {
    this.hasInteracted[type] = true;

    switch (type) {
      case 'area':
        this.selectedArea = event.value ?? null;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }

    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.selectedArea && this.jobPosition);
  }

  onRegister() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const request = {
      nameJobPostion: this.jobPosition,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    this.managementService
      .createJobPosition(formData, Number(this.areaId))
      .subscribe({
        next: (response) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalSuccessComponent, {
            header: '',
            data: {
              text: 'Tu registro ha sido realizado con éxito.',
              title: '¡Éxito!',
              icon: 'pi pi-check-circle',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.registerJobPositionComplete.emit();
          this.closeDialog();
        },

        error: (err) => {
          loadingRef.close();

          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.resetForm();
          this.closeDialog();
        },
      });
    this.closeDialog();
  }

  resetForm() {
    this.jobPosition = null;
    this.hasInteracted = {
      area: false,
      jobPosition: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }
}
